import { connect } from 'react-redux';
import NotificationsSidebar from './NotificationsSidebar';
import { push } from 'redux-little-router';
import { createStructuredSelector } from 'reselect';
import {
  selectNewNotifications,
  selectNotifications,
  selectNotificationsError,
  selectNotificationsHasNextPage,
  selectNotificationsLoading,
  selectNotificationsLoadingMore,
  selectSidebarIsVisible,
  selectNotificationModalVisible,
  selectNotificationModalData,
} from 'modules/Notifications/redux/selectors';

import {
  getMoreNotifications,
  getNotifications,
  hideSidebar,
  readAllNotifications,
  readNotification,
  removeAllNotifications,
  removeNotification,
  showSidebar,
  initializeNotifications,
  stopNotificationsPolling,
  closeNotificationModal,
  showNotificationModal,
} from 'modules/Notifications/redux/actions';
import { selectSiteMap } from 'modules/App/utils/selectors';

const mapStateToProps = createStructuredSelector({
  notifications: selectNotifications,
  newNotifications: selectNewNotifications,
  isLoading: selectNotificationsLoading,
  error: selectNotificationsError,
  sidebarIsVisible: selectSidebarIsVisible,
  fetchingMore: selectNotificationsLoadingMore,
  hasNextPage: selectNotificationsHasNextPage,
  modalIsVisible: selectNotificationModalVisible,
  modalData: selectNotificationModalData,
  siteMap: selectSiteMap,
});

export const mapDispatchToProps = {
  showSidebar,
  hideSidebar,
  getNotifications,
  readNotification,
  removeNotification,
  readAllNotifications,
  removeAllNotifications,
  initializeNotifications,
  stopNotificationsPolling,
  getMoreNotifications,
  closeNotificationModal,
  goToLink: push,
  showNotificationModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsSidebar);
